import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Line = ({ hasNoPadding, hasButtonSibling }) => {
  return (
    <div
      className={cx('title-line__container', {
        '--no-padding': hasNoPadding,
        '--button-sibling': hasButtonSibling,
      })}
    >
      <div className="title-ball"></div>
      <div className="title-line"></div>
    </div>
  )
}

Line.propTypes = {
  hasNoPadding: PropTypes.bool,
  hasButtonSibling: PropTypes.bool,
}

export default Line
